/**
 * Authentication constants
 * These should match the backend configuration
 */

// JWT duration in milliseconds (30 minutes)
// This matches the backend JWT_EXPIRES_IN='30m' setting
export const JWT_DURATION_MS = 30 * 60 * 1000;

// Session timeout warning time in milliseconds (2 minutes before expiry)
export const SESSION_WARNING_TIME_MS = 2 * 60 * 1000;

// LocalStorage key for token expiry time
export const TOKEN_EXPIRY_KEY = 'tokenExpiryTime';
